import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation DeleteAppScenario(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          deleteScenario(id: $scenarioId) {
            id
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.always(undefined)

export const executor = graphql.createExecutor<
  graphql.schema.DeleteAppScenarioMutation,
  void,
  graphql.schema.DeleteAppScenarioMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
